export const LANDING_PAGE_URL = 'https://vizion.space';

export const ROUTE_MAP = {
  overview: {
    id: 'tong-quan',
    label: 'Tổng quan NewStar',
  },
  'floor-plan': {
    id: 'mat-bang-tang',
    label: 'Mặt bằng tầng',
  },
  masterplan: {
    id: 'so-do-tong-the',
    label: 'Sơ đồ tổng thể',
  },
  interior: {
    id: 'can-ho',
    label: 'Căn hộ',
  },
  'can-ho-mau': {
    id: 'can-ho-mau',
    label: 'Căn hộ mẫu',
  },
  neighborhood: {
    id: 'vi-tri',
    label: 'Liên kết vùng',
  },
  amenities: {
    id: 'tien-ich',
    label: 'Tiện ích',
  },
};

export const SCENE_IDS = {
  default: {
    groupId: 'welcome',
    sceneId: '68d12cca208f82c724e17eb7',
  },
};
